import { render, staticRenderFns } from "./staffing-pattern.vue?vue&type=template&id=0885b27c&"
import script from "./staffing-pattern.vue?vue&type=script&lang=js&"
export * from "./staffing-pattern.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports